import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import { FaTrain, FaCheckCircle, FaPhoneAlt } from "react-icons/fa";
import SFservice from "../../Page-section/sales-funnel/SFservice";
import Faq from "../../Page-section/sales-funnel/Faq";
import Portfolio from "../../components/portfolio";

import {
  FaLightbulb,
  FaUsers,
  FaCode,
  FaCogs,
  FaAward,
  FaPaperPlane,
} from "react-icons/fa";

const SFprocess = () => {
  const points = [
    "Reduce drop-offs across funnel ranges",
    "Improve patron enjoy and engagement",
    "Increase lead-to-customer conversion costs",
  ];
  const point = [
    "Targeted visitors campaigns",
    "Engaging lead magnets",
    "Optimized landing pages",
    "Automated follow-ups",
  ];

  const steps = [
    {
      id: 1,
      title: "Funnel Audit & Analysis",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We start through studying your current sales funnel to pick out weak points, drop-offs, and neglected opportunities.",
    },
    {
      id: 2,
      title: "Strategy Development",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "Based on insights, we create a customized funnel optimization strategy tailor-made in your commercial enterprise dreams.",
    },
    {
      id: 3,
      title: "Landing Page Optimization",
      color: "green",
      icon: <FaCode />,
      desc: "We design and optimize high-changing touchdown pages with compelling reproduction, clear CTAs, and user-pleasant layouts.",
    },
    {
      id: 4,
      title: "A/B Testing & Experimentation",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "We constantly test distinct elements which include headlines, CTAs, layouts, and visuals to locate what works great.",
    },
    {
      id: 5,
      title: "Conversion Tracking & Analytics",
      color: "green",
      icon: <FaAward />,
      desc: "We put in force advanced monitoring equipment to reveal consumer behavior and funnel overall performance.",
    },
    {
      id: 6,
      title: "Continuous Optimization",
      color: "#0868a0",
      icon: <FaPaperPlane />,
      desc: "Sales funnel optimization is an ongoing procedure.",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
        <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list">
            <li className="active">
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
            <li>
              <Link to="/web-development-company-in-noida">
                Web Development
              </Link>
            </li>
            <li>
              <Link to="/web-design-services">Web Design</Link>
            </li>
            <li>
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
            <li>
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>
            <li>
              <Link to="/social-media-marketing-services">
                Social Media Marketing
              </Link>
            </li>
            <li>
              <Link to="/ai-automation-services">AI Automation Services</Link>
            </li>

            <li>
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>

            <li>
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
            <li>
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+918368327503"> +91 8368327503</a> |{" "}
              <a href="tel:+919319563429"> +91 9319563429</a>
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>
                <Portfolio />

      </div>
      <div className="sf-main-content">
        <section className="why-container">
          <div className="why-content">
            <h2>Why Sales Funnel Optimization Matters</h2>

            <p>
              Sales funnel optimization plays an important role in improving
              conversion rates and normal industrial business enterprise
              profitability. Even minor upgrades in funnel overall performance
              can result in a big income increase.
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              Maximize advertising and marketing ROI When paired with{" "}
              <b>conversion funnel optimization</b>, organizations can pick out
              bottlenecks and create a frictionless consumer adventure.
            </p>
          </div>
        </section>
        <section className="freight-container">
          <div className="freight-content">
            <h3>Key Elements of Conversion Funnel Optimization</h3>
            <p>
              Conversion funnel optimization specializes in growing the
              proportion of customers who take favored moves. This requires
              non-stop testing, analysis, and refinement.
            </p>
            <div className="freight-boxes">
              <div className="box">
                <div className="icon">
                  <FaTrain />
                </div>
                <div>
                  <h4>Landing Page Optimization</h4>
                  <p>
                    Your landing web page is the inspiration of your funnel. A
                    high-converting page must encompass: <br />
                    <b>1.</b> Clear, keyword-wealthy headlines <br />
                    <b>2.</b> Strong and seen CTAs
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="icon">
                  <FaCheckCircle />
                </div>
                <div>
                  <h4>High-Quality Content Strategy</h4>
                  <p>
                    Content is the spine of powerful lead technology funnels.
                    <br />
                    <b>1.</b> Addressing user pain points <br />
                    <b>2.</b> Providing actionable solutions <br />
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="icon">
                  <FaPhoneAlt />
                </div>
                <div>
                  <h4>Effective Call-to-Actions </h4>
                  <p>
                    CTAs are essential for steerage customers thru your funnel.
                    In conversion funnel optimization, CTAs have to be:
                    <br />
                    <b>1.</b> Clear and movement-pushed
                    <br />
                    <b>2.</b> Visually prominent <br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <SFservice />
        <section className="work-process-section">
          <h3 className="work-title">Our Sales Funnel Optimization Process</h3>
          <p className="work-subtitle">
            We follow a strategic and facts-driven technique to optimize every
            level of your sales funnel and enhance usual performance. Our manner
            is designed to identify gaps, remove drop-offs, and beautify person
            enjoy so that greater traffic convert into qualified leads and
            paying customers.
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>Lead Generation Funnels That Convert</h2>

            <p>
              Creating powerful <b>lead generation funnels</b> is critical for
              business boom. We layout funnels that not most effective entice
              site visitors however also convert them into certified leads.
            </p>

            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              With our superior sales funnel services, your lead era funnels
              will consistently supply awesome leads.
            </p>
          </div>
        </section>
        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <div className="title-row">
                <h3>Why Choose Us for Sales Funnel Optimization</h3>

                <p>
                  We help groups turn traffic into paying customers with
                  information-driven, high-converting income funnel optimization
                  strategies. Our technique makes a speciality of enhancing
                  every stage of your funnel to maximize leads, enhance
                  conversions, and boom revenue.
                </p>
              </div>
            </div>

            <div className="cards">
              <div className="card">
                <h3>Proven Funnel Results</h3>
              </div>
              <div className="card">
                <h3>Funnel Optimization Experts</h3>
              </div>
              <div className="card">
                <h3>Customized Funnel Strategy</h3>
              </div>
              <div className="card">
                <h3>Affordable Optimization Plans</h3>
              </div>
              <div className="card">
                <h3>Client-Centric Approach</h3>
              </div>
            </div>
          </div>
        </section>
        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>The Role of Sales Funnel Services</h3>
          </div>
          <div className="operations-right">
            <p>
              Professional <b>sales funnel services</b> provide businesses with
              professional techniques and equipment to construct and optimize
              high-appearing funnels. <br /><br /> 1. Funnel strategy and planning <br />
              2. Landing page design and development <br />
              3. CRM and automation integration
            </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default SFprocess;
